<template>
	<div v-if="user">
		<el-space fill class="w-100" size="large">
			<div class="card">
				<div class="card-body">
					<h5>
						Informasi Profil Pengguna
						<hr />
					</h5>
					<el-row :gutter="20">
						<el-col :span="24" :md="10" :xl="12" class="order-0 order-lg-1 my-1">
							<div class="text-center position-relative">
								<el-image
									v-if="user.foto"
									style="width: 180px; height: 180px"
									:src="user.fotoPath"
									:preview-src-list="[user.fotoPath]"
									show-progress
									fit="contain"
									class="rounded rounded-circle shadow bg-white border">
									<template #error>
										<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
											<el-icon class="fs-2"><Picture /></el-icon>
											<em class="small">Gagal dimuat</em>
										</el-space>
									</template>
								</el-image>
								<img v-else src="../assets/person.png" width="180" height="180" class="mb-2" />
								<h4 class="mb-0">{{ user.nama }}</h4>
								<span v-if="user.type === 'siswa'">{{ [user.nama_rombel, user.nis].join(" - ") }}</span>
								<div class="text-secondary">
									<code>{{ user.username }}</code>
									<em> ~ {{ userTypes.filter((t) => t.type === user.type)[0]?.keterangan }}</em>
								</div>
								<div class="text-secondary small">{{ deskripsiRole }}</div>
								<el-button type="danger" plain round class="position-absolute top-0 end-0" @click="logout">
									<el-icon><i class="bi bi-escape me-2"></i></el-icon>Keluar
								</el-button>
							</div>
						</el-col>
						<el-col :span="24" :sm="20" :md="14" :xl="12" class="order-1 order-lg-0 my-1">
							<el-form :model="userForm" :rules="userRules" @submit.prevent="updateUser" ref="userFormRef" label-width="auto" label-position="right" :disabled="userLoading">
								<el-form-item label="Nama Lengkap" prop="nama">
									<el-input v-if="user.type === 'admin'" v-model="userForm.nama" :placeholder="user.nama" type="text" clearable autocomplete="off" />
									<el-popover v-else trigger="hover" width="240px">
										<template #reference>
											<el-input :placeholder="user.nama" readonly />
										</template>
										<template #default>Silakan hubungi Administrator untuk memperbarui nama</template>
									</el-popover>
								</el-form-item>
								<el-form-item label="Kontak" prop="kontak">
									<el-input v-model="userForm.kontak" :placeholder="user.kontak || 'Masukkan kontak'" type="text" clearable autocomplete="off" />
								</el-form-item>
								<el-form-item label="Foto Profil" class="mb-0">
									<el-space fill direction="vertical" size="small">
										<el-space wrap>
											<el-upload action="" :auto-upload="false" :show-file-list="false" :on-change="handleFotoChange" accept="image/*">
												<template #trigger>
													<el-button icon="Refresh" v-if="foto" type="primary" plain>Ubah gambar</el-button>
													<el-button icon="Camera" v-else type="info">{{ user.foto ? "Perbarui foto profil" : "Pilih gambar" }}</el-button>
												</template>
											</el-upload>
											<el-button v-if="userForm.foto" icon="Delete" type="danger" plain @click="handleFotoChange(null)">Hapus</el-button>
										</el-space>
										<transition name="slide-up" mode="out-in">
											<el-image
												v-if="userForm.foto"
												:key="userForm.foto"
												style="width: 180px; height: auto"
												:src="userForm.previewFoto"
												:preview-src-list="[userForm.previewFoto]"
												show-progress
												fit="cover"
												lazy
												class="shadow bg-white border">
												<template #error>
													<el-space direction="vertical" :size="2" class="w-100 py-4 text-secondary">
														<el-icon class="fs-2"><Picture /></el-icon>
														<em class="small">Gagal dimuat</em>
													</el-space>
												</template>
											</el-image>
										</transition>
										<el-checkbox v-if="user.foto" v-model="userForm.reset_foto" label="Hapus foto profil" border />
									</el-space>
								</el-form-item>
								<hr />
								<div class="text-end">
									<el-button type="primary" :loading="userLoading" native-type="submit">Simpan</el-button>
								</div>
							</el-form>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="card">
				<div class="card-body">
					<el-col :xs="24" :sm="20" :md="14" :xl="12">
						<h5>Perbarui Kata Sandi</h5>
						<hr />
						<el-form
							:model="passwordForm"
							:rules="passwordRules"
							@submit.prevent="updatePassword"
							ref="passwordFormRef"
							label-width="auto"
							label-position="right"
							:disabled="passwordLoading"
							hide-required-asterisk>
							<el-form-item label="Kata Sandi Baru" prop="password">
								<el-input v-model="passwordForm.password" placeholder="Masukkan kata sandi baru" type="password" show-password clearable autocomplete="off" />
							</el-form-item>
							<el-form-item label="Konfirmasi Kata Sandi Baru" prop="confirm_password">
								<el-input v-model="passwordForm.confirm_password" placeholder="Masukkan ulang kata sandi baru" type="password" show-password clearable autocomplete="off" />
							</el-form-item>
							<hr />
							<div class="text-end">
								<el-button type="primary" :loading="passwordLoading" native-type="submit">Simpan</el-button>
							</div>
						</el-form>
					</el-col>
				</div>
			</div>
		</el-space>
	</div>
</template>

<script>
export default {
	name: "ProfileView",
	data() {
		return {
			userTypes: [
				{ type: "admin", keterangan: "Administrator" },
				{ type: "guru", keterangan: "Guru" },
				{ type: "karyawan", keterangan: "Tenaga Kependidikan" },
				{ type: "siswa", keterangan: "Siswa" },
			],
			userForm: {
				nama: null,
				kontak: null,
				foto: null,
				previewFoto: "",
				reset_foto: false,
			},
			passwordForm: {
				password: null,
				confirm_password: null,
			},
			userRules: {
				nama: [{ required: false, message: "Opsional", trigger: "change" }],
				kontak: [{ required: false, pattern: /^[0-9]{9,13}$/, message: "Kontak terdiri dari 9-13 digit angka tanpa spasi atau karakter lain", trigger: "change" }],
			},
			passwordRules: {
				password: [
					{ required: true, message: "Silakan masukkan kata sandi baru", trigger: "change" },
					{ min: 8, message: "Kata sandi setidaknya terdiri dari 8 karakter atau lebih", trigger: "blur" },
				],
				confirm_password: [
					{ required: true, message: "Silakan masukkan ulang kata sandi baru", trigger: "change" },
					{ validator: this.cekKonfirmasiPassword, trigger: "blur" },
				],
			},
			userLoading: false,
			passwordLoading: false,
		};
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		},
		deskripsiRole() {
			const roles = this.$store.getters.getRoles;
			return roles?.map((r) => r.deskripsi).join(", ");
		},
	},
	watch: {
		"userForm.reset_foto"(val) {
			if (val) {
				this.userForm.foto = null;
			}
		},
	},
	mounted() {},
	beforeUnmount() {},
	methods: {
		cekKonfirmasiPassword(rule, value, cb) {
			if (value !== this.passwordForm.password) {
				cb(new Error("Konfirmasi kata sandi baru tidak sesuai!"));
			} else {
				cb();
			}
		},
		handleFotoChange(file) {
			if (file) {
				const isLt2M = file?.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.userForm.foto = null;
					this.userForm.previewFoto = "";
					return this.$message.error("Ukuran gambar tidak boleh lebih dari 2MB!");
				}

				this.userForm.foto = file.raw;
				this.userForm.previewFoto = URL.createObjectURL(file.raw);
				this.userForm.reset_foto = false;
			} else {
				this.userForm.foto = null;
				this.userForm.previewFoto = "";
			}
		},
		async updateUser() {
			this.userLoading = true;

			const formData = new FormData();
			formData.append("nama", this.userForm.nama);
			formData.append("kontak", this.userForm.kontak);
			formData.append("reset_foto", this.userForm.reset_foto);
			formData.append("foto", this.userForm.foto);

			try {
				const valid = await this.$refs.userFormRef.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}
				if (!this.userForm.nama && !this.userForm.kontak && !this.userForm.reset_foto && !this.userForm.foto) {
					throw Error("Anda belum melakukan perubahan");
				}

				const { data } = await this.$authApi.post("/profile/update", formData);
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});

				this.$refs.userFormRef.resetFields();
				this.userForm.foto = null;
				this.userForm.previewFoto = "";
				this.userLoading = false;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.userLoading = false;
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			}
		},
		async updatePassword() {
			this.passwordLoading = true;
			try {
				const valid = await this.$refs.passwordFormRef.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan kata sandi baru dan konfirmasi sesuai dengan ketentuan");
				}

				const { data } = await this.$authApi.post("/profile/update-credential", this.passwordForm);
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});

				this.$refs.passwordFormRef.resetFields();
				this.passwordLoading = false;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
				this.passwordLoading = false;
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			}
		},
		async logout() {
			await this.$store.dispatch("logoutUser");
		},
	},
};
</script>

<style scoped>
.el-checkbox {
	--el-checkbox-checked-text-color: var(--el-color-danger);
	--el-checkbox-checked-input-border-color: var(--el-color-danger);
	--el-checkbox-checked-bg-color: var(--el-color-danger);
	--el-checkbox-text-color: var(--el-color-danger);
	--el-checkbox-input-border-color-hover: var(--el-color-danger);
	--el-checkbox-input-border: 1px solid var(--el-color-danger-light-5);
}
.el-checkbox.is-bordered {
	border-color: var(--el-color-danger-light-5);
}
.el-checkbox.is-bordered.is-checked {
	border-color: var(--el-color-danger);
	background-color: var(--el-color-danger-light-9);
}
</style>
